import gql from 'graphql-tag';

export default gql`
	mutation UpdateLanguage($language: String!, $id: Int) {
		updateUser(changes: { language: $language }, id: $id) {
			language
		}
	}
`;
